module.exports = __webpack_public_path__ + "img/3.4b5faec2.png";